import React from 'react';
import { Card, Typography, Space, Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';

const { Text } = Typography;

// Contrato de GET /api/professor/avaliacoes (ResumoAvaliacaoTurmaProfessorResponse):
// id_periodo, nome_periodo, data_abertura, data_encerramento, status_periodo,
// id_avaliacao_turma, id_turma, nome_turma, nome_modalidade, total_alunos,
// total_pendente, total_rascunho, total_aguardando_validacao, total_publicada.
// Card inteiro clicável (Card hoverable + onClick) -- nenhum botão pequeno
// isolado, professor precisa tocar uma área grande no celular.

const AvaliacaoTurmaProfessorCard = ({ resumo, onAbrir }) => {
  const encerrado = resumo.status_periodo === 'ENCERRADO';

  return (
    <Card
      className="portal-professor__card"
      hoverable
      onClick={() => onAbrir(resumo)}
      data-testid="avaliacao-turma-card"
    >
      <div className="portal-professor__card-row">
        <Space direction="vertical" size={2} style={{ minWidth: 0, flex: '1 1 auto' }}>
          <Text strong style={{ fontSize: 16, lineHeight: 1.3, wordBreak: 'break-word' }}>
            {resumo.nome_turma}
          </Text>
          <Text type="secondary" style={{ fontSize: 13, wordBreak: 'break-word' }}>
            {resumo.nome_modalidade}
          </Text>
          <Text style={{ fontSize: 13 }}>
            {resumo.total_publicada} de {resumo.total_alunos} publicadas
          </Text>
          {resumo.total_aguardando_validacao > 0 && (
            <Text type="secondary" style={{ fontSize: 13 }}>
              {resumo.total_aguardando_validacao} aguardando validação
            </Text>
          )}
          {resumo.total_rascunho > 0 && (
            <Text type="secondary" style={{ fontSize: 13 }}>
              {resumo.total_rascunho} em andamento
            </Text>
          )}
          {resumo.total_pendente > 0 && (
            <Text type="secondary" style={{ fontSize: 13 }}>
              {resumo.total_pendente} não iniciada{resumo.total_pendente > 1 ? 's' : ''}
            </Text>
          )}
        </Space>

        <Button
          className="portal-professor__card-action"
          type={encerrado ? 'default' : 'primary'}
          aria-label={`${encerrado ? 'Consultar' : 'Continuar'} avaliações de ${resumo.nome_turma}`}
          icon={<RightOutlined />}
          iconPosition="end"
        >
          {encerrado ? 'Consultar' : 'Continuar avaliações'}
        </Button>
      </div>
    </Card>
  );
};

export default AvaliacaoTurmaProfessorCard;
